import { normaliseEmailArray, normaliseStrArray } from "src/utils/arrayNormalisation";
import { CreateUserAccountFormData, PostUserAccountRequestBody, UserRole } from "src/types";

export class CreateUserAccountMapper {
  public static initCreateUserAccountFormData(userRoleDefaultValue: UserRole = "NONE"): CreateUserAccountFormData {
    return {
      email: "",
      name: "",
      jobTitle: "",
      supervisorEmails: [""],
      vendorNames: [""],
      role: userRoleDefaultValue
    };
  }

  public static createUserAccountRequestBodyFromFormData(
    formData: CreateUserAccountFormData
  ): PostUserAccountRequestBody {
    const normalisedJobTitle = formData.jobTitle || undefined;
    const normalisedSupervisorEmails = normaliseEmailArray(formData.supervisorEmails);
    const normalisedVendorNames = normaliseStrArray(formData.vendorNames);

    return {
      email: formData.email,
      name: formData.name,
      role: formData.role,
      jobTitle: normalisedJobTitle,
      supervisorEmails: normalisedSupervisorEmails?.length ? normalisedSupervisorEmails : undefined,
      vendorNames: normalisedVendorNames?.length ? normalisedVendorNames : undefined
    };
  }
}
